let listener = null;

export const rateLimitStore = {
  set(data) {
    listener && listener(data);
  },
  subscribe(fn) {
    listener = fn;
  },
};